const PERMISSION_KEY= "core:securities_sub_account";
const PAGE_URL = {
    SECURITIES_SUB_ACCOUNT_PAGE: "/admin/core/securities-sub-account"
}

export {PERMISSION_KEY, PAGE_URL}

